import { render, staticRenderFns } from "./sampleReception.vue?vue&type=template&id=5f99baf5"
import script from "./sampleReception.ts?vue&type=script&lang=js&external"
export * from "./sampleReception.ts?vue&type=script&lang=js&external"
import style0 from "./sampleReception.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports